// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as privateRouteRouteImport } from './routes/(private)/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as privateIndexRouteImport } from './routes/(private)/index'
import { Route as privateCorrectionsRouteImport } from './routes/(private)/corrections'
import { Route as privateAdminsRouteImport } from './routes/(private)/admins'
import { Route as privateSplatRouteImport } from './routes/(private)/$'
import { Route as privateProfileRouteRouteImport } from './routes/(private)/profile/route'
import { Route as privateDocumentsRouteRouteImport } from './routes/(private)/documents/route'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authAcceptInviteRouteImport } from './routes/(auth)/accept-invite'
import { Route as privateEsclusiveIndexRouteImport } from './routes/(private)/esclusive/index'
import { Route as privateConfigurationIndexRouteImport } from './routes/(private)/configuration/index'
import { Route as privateProfileIndexRouteImport } from './routes/(private)/profile/index'
import { Route as privateProfileSecurityRouteImport } from './routes/(private)/profile/security'
import { Route as privateProfilePersonalRouteImport } from './routes/(private)/profile/personal'
import { Route as privateDocumentsIndexRouteImport } from './routes/(private)/documents/index'
import { Route as privateDocumentsRunIdRouteImport } from './routes/(private)/documents/$runId'

const privateRouteRoute = privateRouteRouteImport.update({
            id: '/(private)',getParentRoute: () => rootRouteImport
          })
const authRouteRoute = authRouteRouteImport.update({
            id: '/(auth)',getParentRoute: () => rootRouteImport
          })
const privateIndexRoute = privateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateRouteRoute
          })
const privateCorrectionsRoute = privateCorrectionsRouteImport.update({
            id: '/corrections',path: '/corrections',getParentRoute: () => privateRouteRoute
          })
const privateAdminsRoute = privateAdminsRouteImport.update({
            id: '/admins',path: '/admins',getParentRoute: () => privateRouteRoute
          })
const privateSplatRoute = privateSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => privateRouteRoute
          })
const privateProfileRouteRoute = privateProfileRouteRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => privateRouteRoute
          })
const privateDocumentsRouteRoute = privateDocumentsRouteRouteImport.update({
            id: '/documents',path: '/documents',getParentRoute: () => privateRouteRoute
          })
const authResetPasswordRoute = authResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => authRouteRoute
          })
const authLoginRoute = authLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => authRouteRoute
          })
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => authRouteRoute
          })
const authAcceptInviteRoute = authAcceptInviteRouteImport.update({
            id: '/accept-invite',path: '/accept-invite',getParentRoute: () => authRouteRoute
          })
const privateEsclusiveIndexRoute = privateEsclusiveIndexRouteImport.update({
            id: '/esclusive/',path: '/esclusive/',getParentRoute: () => privateRouteRoute
          })
const privateConfigurationIndexRoute = privateConfigurationIndexRouteImport.update({
            id: '/configuration/',path: '/configuration/',getParentRoute: () => privateRouteRoute
          })
const privateProfileIndexRoute = privateProfileIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateProfileRouteRoute
          })
const privateProfileSecurityRoute = privateProfileSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => privateProfileRouteRoute
          })
const privateProfilePersonalRoute = privateProfilePersonalRouteImport.update({
            id: '/personal',path: '/personal',getParentRoute: () => privateProfileRouteRoute
          })
const privateDocumentsIndexRoute = privateDocumentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateDocumentsRouteRoute
          })
const privateDocumentsRunIdRoute = privateDocumentsRunIdRouteImport.update({
            id: '/$runId',path: '/$runId',getParentRoute: () => privateDocumentsRouteRoute
          })





const authRouteRouteChildren = {
  authAcceptInviteRoute: authAcceptInviteRoute,authForgotPasswordRoute: authForgotPasswordRoute,authLoginRoute: authLoginRoute,authResetPasswordRoute: authResetPasswordRoute
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(authRouteRouteChildren)




const privateDocumentsRouteRouteChildren = {
  privateDocumentsRunIdRoute: privateDocumentsRunIdRoute,privateDocumentsIndexRoute: privateDocumentsIndexRoute
}

const privateDocumentsRouteRouteWithChildren = privateDocumentsRouteRoute._addFileChildren(privateDocumentsRouteRouteChildren)




const privateProfileRouteRouteChildren = {
  privateProfilePersonalRoute: privateProfilePersonalRoute,privateProfileSecurityRoute: privateProfileSecurityRoute,privateProfileIndexRoute: privateProfileIndexRoute
}

const privateProfileRouteRouteWithChildren = privateProfileRouteRoute._addFileChildren(privateProfileRouteRouteChildren)



const privateRouteRouteChildren = {
  privateDocumentsRouteRoute: privateDocumentsRouteRouteWithChildren,privateProfileRouteRoute: privateProfileRouteRouteWithChildren,privateSplatRoute: privateSplatRoute,privateAdminsRoute: privateAdminsRoute,privateCorrectionsRoute: privateCorrectionsRoute,privateIndexRoute: privateIndexRoute,privateConfigurationIndexRoute: privateConfigurationIndexRoute,privateEsclusiveIndexRoute: privateEsclusiveIndexRoute
}

const privateRouteRouteWithChildren = privateRouteRoute._addFileChildren(privateRouteRouteChildren)

const rootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,privateRouteRoute: privateRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)